<div class="rating">
  <p style="font-size: 14px">{{ currentRate.toFixed(1) }}</p>
  @for (star of stars; track $index) {
    <span
      (click)="rate($index + 1)"
      class="star">
    @if ($index < currentRate) {
      <img src="/icons/star.svg">
    } @else {
      <img src="/icons/star-free.svg">
    }
  </span>
  }
</div>
